import * as React from 'react';
import * as moment from 'moment-timezone';


import './FeedItemContent.pcss';


export const FeedItemContent = (props:{title:string, fromDate?:string, toDate?:string, unread:boolean, children:any}) =>
<div className="feed-item-content">
	<h3 className="title">{props.title}</h3>
	<DateLine fromDate={props.fromDate} toDate={props.toDate} />
	<div className="body">{props.children}</div>
</div>
;

const DateLine = (props:{ fromDate?:string, toDate?:string }) => {
	if(props.fromDate && props.toDate){
		const fromDate = moment(props.fromDate);
		const toDate = moment(props.toDate);
		let dateLine = fromDate.tz(moment.tz.guess()).format('MMMM Do, h:mm a' );
		dateLine += ' – ' + ((fromDate.isAfter(toDate, 'day')) ? toDate.tz(moment.tz.guess()).format('MMMM Do, h:mm a' ) : toDate.tz(moment.tz.guess()).format('h:mm a'));
		return <div className="eventDateLine">{dateLine}</div>
	} else {
		return null;
	}
};


